import { useId, type ReactNode } from "react";
import { List, ListSubheader } from "@mui/material";

export type UsedByGroupProps = {
  title: string;
  children: ReactNode;
};

/** One labelled group ("Rules", "Shared matches", …) in the used-by list. */
export const UsedByGroup = ({ title, children }: UsedByGroupProps) => {
  const headingId = useId();
  return (
    <>
      <ListSubheader
        id={headingId}
        component="div"
        disableSticky
        // Inherit the popover's elevated paper: the subheader's own background
        // is the base paper colour, which bands visibly in dark mode.
        sx={{ lineHeight: "36px", bgcolor: "inherit" }}
      >
        {title}
      </ListSubheader>
      <List dense disablePadding aria-labelledby={headingId}>
        {children}
      </List>
    </>
  );
};
